<script>
  import { clientStore } from '../../stores';
  import { config } from '../../../scripts/defaultURL';
  import { clearForm } from '../../../scripts/functions';
  import { postData } from '../../../scripts/rest';

  let payload = {};

  function closeModal() {
    clearForm('#clientModal input');
    payload = {};
    document.getElementById('clientModal').classList.remove('is-active')
    if (!$clientStore) $clientStore = {};
    $clientStore['todo'] = 'getData';
  }

    function save() {
      console.log('payload', payload);

      postData(`${config.defaultURL}/clients/add`, payload)
      .catch((error) => console.error('Failed to post client:', error))
      .then((res) => {
        console.log(res)
        closeModal()
      })
    }

</script>

<style>
  .modal-card-title {
    margin-bottom: 0 !important;
  }
</style>

<div class="modal" id="clientModal">
  <div class="modal-background" />
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Add Client</p>
      <button on:click={closeModal} class="delete" aria-label="close" />
    </header>
    <section class="modal-card-body">
      <div class="rows">
        <div class="row is-full">
          <div class="columns">
            <div class="column">
              <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">First</label>
                <input bind:value={payload.first} class="input" type="text" name="first" placeholder="First Name" />
              </div>
            </div>
            <div class="column">
              <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">Last</label>
                <input bind:value={payload.last} type="text" class="input" name="last" placeholder="Last Name" />
              </div>
            </div>
          </div>
        </div>
        <div class="row is-full">
          <div class="columns">
            <div class="column">
              <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">Email</label>
                <input bind:value={payload.email} type="email" class="input" name="email" placeholder="Email Address" />
              </div>
            </div>
            <div class="column">
              <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">Phone</label>
                <input bind:value={payload.phone} type="text" class="input" name="phone" placeholder="Phone Number" />
              </div>
            </div>
          </div>
        </div>
      </div>      
      <div class="field">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="label">Street</label>
        <input bind:value={payload.street} type="text" class="input" name="street" placeholder="Street Address" />
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">City</label>
            <input bind:value={payload.city} type="text" class="input" name="city" placeholder="City" />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">State</label>
            <input bind:value={payload.state} type="text" class="input" name="state" placeholder="State" />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Zip Code</label>
            <input bind:value={payload.zip} type="text" class="input" name="zip" placeholder="Zip Code" />
          </div>
        </div>
      </div>
      <div class="field">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="label">Birthday</label>
        <input bind:value={payload.dob} type="date" class="input" name="dob" placeholder="Birthday" />
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button on:click={save} class="button is-primary">Submit</button>
        </div>
        <div class="control">
          <button
            on:click={closeModal}
            class="button is-primary is-light">Cancel</button>
        </div>
      </div>
    </section>
  </div>
</div>
